import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Markus Brunner',
  school: 'Berufsfachschule BBZ',
  city: 'Zürich'
}, {
  name: 'Stefan Müller',
  school: 'Gewerbliche Berufsschule',
  city: 'Bern'
}, {
  name: 'Andreas Keller',
  school: 'Berufsbildungszentrum BBZB',
  city: 'Basel'
}, {
  name: 'Thomas Schneider',
  school: 'BBZ Olten',
  city: 'Olten'
}, {
  name: 'Daniel Weber',
  school: 'GBS St. Gallen',
  city: 'St. Gallen'
}, {
  name: 'Patrick Aebi',
  school: 'Berufsschule Winterthur',
  city: 'Winterthur'
}, {
  name: 'Michael Furrer',
  school: 'BBZ Luzern',
  city: 'Luzern'
}, {
  name: 'Roland Frei',
  school: 'TBZ Zürich',
  city: 'Zürich'
}, {
  name: 'Beat Hofer',
  school: 'Gewerbeschule Aarau',
  city: 'Aarau'
}, {
  name: 'Christian Steiner',
  school: 'BBZ Solothurn',
  city: 'Solothurn'
}, {
  name: 'Reto Bühler',
  school: 'BFS Thun',
  city: 'Thun'
}, {
  name: 'Urs Lehmann',
  school: 'Berufsschule Baden',
  city: 'Baden'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  const [timeAgo, setTimeAgo] = useState(2);
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNextBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showNextBuyer = () => {
    const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
    const randomTime = Math.floor(Math.random() * 15) + 1;
    setCurrentBuyer(randomBuyer);
    setTimeAgo(randomTime);
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(() => {
        showNextBuyer();
      }, Math.random() * 8000 + 12000);
    }, 6000);
  };
  return <AnimatePresence data-id="element-175">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: 50,
      y: -20
    }} animate={{
      opacity: 1,
      x: 0,
      y: 0
    }} exit={{
      opacity: 0,
      x: 50,
      scale: 0.9
    }} className="fixed top-3 right-3 sm:top-6 sm:right-6 z-50 max-w-[290px] w-[calc(100%-1.5rem)] sm:w-full" data-id="element-176">
          <div className="bg-white border border-gray-200 rounded-xl p-3.5 shadow-lg relative overflow-hidden" data-id="element-177">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Schliessen" data-id="element-178">
              <XIcon className="w-4 h-4" data-id="element-179" />
            </button>

            <div className="flex items-start gap-3" data-id="element-180">
              <div className="w-10 h-10 rounded-full bg-brand-swiss-red flex items-center justify-center text-white font-bold text-lg shrink-0" data-id="element-181">
                {currentBuyer.name.charAt(0)}
              </div>
              <div className="pr-4 min-w-0" data-id="element-182">
                <p className="text-[12px] sm:text-sm text-gray-700 leading-tight" data-id="element-183">
                  <span className="font-bold text-brand-charcoal" data-id="element-184">
                    {currentBuyer.name}
                  </span>{' '}
                  ({currentBuyer.school}, {currentBuyer.city}) hat soeben SPS
                  PRO gekauft
                </p>
                <div className="flex items-center gap-2 mt-1.5" data-id="element-185">
                  <span className="flex items-center gap-1 text-[10px] sm:text-xs text-brand-green-cta font-bold" data-id="element-186">
                    <span className="w-1.5 h-1.5 rounded-full bg-brand-green-cta animate-pulse" data-id="element-187" />
                    Verifiziert 🇨🇭
                  </span>
                  <span className="text-[10px] sm:text-xs text-gray-500" data-id="element-188">
                    · vor {timeAgo} Min.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}